import { render, staticRenderFns } from "./ReratedCourses.vue?vue&type=template&id=59cd77aa&"
import script from "./ReratedCourses.vue?vue&type=script&lang=js&"
export * from "./ReratedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports